import { render } from "./Partner.vue?vue&type=template&id=72d1789f&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=72d1789f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72d1789f"

export default script